import { SwapKitNumber } from "@swapkit/core";

import { ThornodeTransactionDetails } from "./types";

export const parseTransactionDetails = (details: ThornodeTransactionDetails) => {
  const amount = details?.tx?.body?.messages?.[0]?.amount?.[0]?.amount || "0";

  const ok = details?.tx_response?.code === 0;

  return {
    txHash: details?.tx_response?.txhash,
    from: details?.tx?.body?.messages?.[0]?.from_address,
    to: details?.tx?.body?.messages?.[0]?.to_address,
    amount: SwapKitNumber.fromBigInt(BigInt(amount)),
    ok,
    error: ok ? false : details?.tx_response?.raw_log,
    createdAt: details?.tx_response?.timestamp,
  };
};
